/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { SimpleAction } from './simple-action';
import { DatePipe } from '@angular/common';
import { CommonUtils } from '../common-utils';

export class DateAction extends SimpleAction<Date> {
  public dateMin: Date;
  public dateMax: Date;
  public title: string;
  public label: string;
  public mode: 'day' | 'week' | 'month' | 'resources' = 'day';
  constructor(
    name: string,
    text: string,
    defaultDate: Date,
    icon?: string,
    align?: 'left' | 'center' | 'right'
  ) {
    super(name, icon ? icon : 'calendar-alt', defaultDate, text);
    if (align) {
      this.align = align;
    }
    this.category = 'date';
    this.label = this.generateLabel(defaultDate);
  }

  public setMode(mode: 'day' | 'week' | 'month' | 'resources') {
    this.mode = mode;
    if (this.value) {
      this.label = this.generateLabel(this.value);
    }
  }

  public setLimit(limit: { dateMin?: Date; dateMax?: Date }) {
    this.dateMin = limit.dateMin;
    this.dateMax = limit.dateMax;
  }

  override getActionType(): string {
    return 'date';
  }

  public changeLabel(date: Date): string {
    this.value = date;
    this.label = this.generateLabel(date);
    return this.label;
  }

  private generateLabel(date: Date): string {
    const pipe = new DatePipe('fr');
    switch (this.mode) {
      case 'day':
        return CommonUtils.convertDateToString(date);
      case 'month':
        return pipe.transform(date, 'MMM yyyy');
      case 'week':
        return this.labelForWeek(date);
    }
    return undefined;
  }

  private labelForWeek(date: Date): string {
    const start = CommonUtils.startOfTheWeek(date);
    const end = CommonUtils.endOfTheWeek(date);
    const pipe = new DatePipe('fr');

    if (
      start.getMonth() === end.getMonth() &&
      start.getFullYear() === end.getFullYear()
    ) {
      return `${pipe.transform(start, 'dd')} - ${pipe.transform(
        end,
        'dd'
      )} ${pipe.transform(start, 'MMM yyyy')}`;
    }
    if (start.getFullYear() === end.getFullYear()) {
      return `${pipe.transform(start, 'dd MMM')} - ${pipe.transform(
        end,
        'dd MMM'
      )} ${pipe.transform(start, 'yyyy')}`;
    }
    return `${pipe.transform(start, 'dd MMM yyyy')} - ${pipe.transform(
      end,
      'dd MMM yyyy'
    )}`;
  }

  public next() {
    this.updateDate(1);
  }

  public previous() {
    this.updateDate(-1);
  }

  private updateDate(amount: number) {
    switch (this.mode) {
      case 'day':
        this.value = CommonUtils.addDayToDate(this.value, amount);
        break;
      case 'month':
        this.value.setMonth(this.value.getMonth() + amount);
        this.value = new Date(this.value);
        break;
      case 'week':
        this.value = CommonUtils.addWeekToDate(this.value, amount);
        break;
    }
    this.label = this.generateLabel(this.value);
  }
}
